export class OpportunityType {
    constructor(
        public id: number = 0,
        public name: string = null
    ) { }
}